<template>
    <v-app class="blog-page faq-page">
        <Qna
            :qna="qna"
            :categories="categories"
            :filter="filter"
            :page="page"
        />
    </v-app>
</template>
<script>
import Qna from './Qna'

export default {
    props: ['qna', 'categories', 'filter', 'page'],

    components: {
        Qna
    },
}
</script>


// WEBPACK FOOTER //
// resources/js/components/blog/Faq.vue